/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListShadowMCPInventorySecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListShadowMCPInventoryRequest = {
  projectId: string;
  limit?: number | undefined;
  /**
   * Cursor for the next page of results.
   */
  cursor?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListShadowMCPInventorySecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListShadowMCPInventorySecurity$outboundSchema: z.ZodMiniType<
  ListShadowMCPInventorySecurity$Outbound,
  ListShadowMCPInventorySecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listShadowMCPInventorySecurityToJSON(
  listShadowMCPInventorySecurity: ListShadowMCPInventorySecurity,
): string {
  return JSON.stringify(
    ListShadowMCPInventorySecurity$outboundSchema.parse(
      listShadowMCPInventorySecurity,
    ),
  );
}

/** @internal */
export type ListShadowMCPInventoryRequest$Outbound = {
  project_id: string;
  limit: number;
  cursor?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListShadowMCPInventoryRequest$outboundSchema: z.ZodMiniType<
  ListShadowMCPInventoryRequest$Outbound,
  ListShadowMCPInventoryRequest
> = z.pipe(
  z.object({
    projectId: z.string(),
    limit: z._default(z.int(), 50),
    cursor: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectId: "project_id",
      gramSession: "Gram-Session",
    });
  }),
);

export function listShadowMCPInventoryRequestToJSON(
  listShadowMCPInventoryRequest: ListShadowMCPInventoryRequest,
): string {
  return JSON.stringify(
    ListShadowMCPInventoryRequest$outboundSchema.parse(
      listShadowMCPInventoryRequest,
    ),
  );
}
